export default {
    id: "c0f4d54c-e9f3-48b0-845e-898910aa421f",
    icon: "mdi-rectangle",
    name: "shapeRectangle",
    title: "Shape Rectangle",
    description: "A block rectangle",
}